export default "__VITE_ASSET__8d54a9a7__"